<template>
  <v-main style="background-color: #b0bec5">
    <v-container fluid style="max-width: 400px; height: 100%;" class="pa-0 d-flex">
      <vue-headful title="Mein Wochenreport" description="aimz"/>
      <div class="d-flex pa-0" style="width: 100%;">
        <v-col class="mt-3 d-flex align-stretch pa-0">
          <div class="full_width">
          <week-paginator :date="date" :nr="undefined" base-url="/report/" class="mb-2"></week-paginator>

          <v-card style="width: 100%;">
            <v-card-title class="">
              <div class="full_width text-center">
                Mein Wochenbericht
              </div>
            </v-card-title>
            <v-card-text>

              <!--              index-->
              <div v-if="loading>0" class="mt-6 mr-2 rounded-lg full_width" style="border: 1px solid #cccccc;">
                <div class="display-4 text-center mb-2 mt-1">
                  <div class="text-button">Mein Leben</div>
                  <!--                  <v-icon class="d-inline-block mt-n2 ml-n2" :size="36" color="orange">mdi-fire</v-icon>-->
                  <span>{{ thisWeek.index || 0 }}</span>
                </div>
                <v-divider/>
                <div class="text-center full_width pa-4" v-html="getIndexBeurteilung(thisWeek.index)">
                </div>
                <v-divider/>
                <div class="d-flex justify-space-around pa-4 pb-2">
                  <div class="text-center">
                    <span class="display-1">{{ beforeLastWeek.index || 0 }}</span>
                    <p class="text-center text-caption">vorletzte Woche</p>
                  </div>
                  <div class="text-center">
                    <span class="display-1">{{ lastWeek.index || 0 }}</span>
                    <p class="text-center text-caption">letzte Woche</p>
                  </div>
                  <div class="text-center">
                    <span class="display-1">{{ thisWeek.index || 0 }}</span>
                    <p class="text-center text-caption">diese Woche</p>
                  </div>
                </div>
              </div>
              <div v-else class="mt-6 mr-2 rounded-lg full_width" style="border: 1px solid #cccccc; overflow: hidden;">
                <div class="text-button full_width text-center">Mein Leben</div>
                <div class="d-flex justify-space-around ma-4">
                  <v-progress-circular indeterminate class="mx-auto" color="gelb"></v-progress-circular>
                </div>
              </div>

              <!--              happyness -->
              <div v-if="loading>1" class="mt-6 mr-2 rounded-lg full_width" style="border: 1px solid #cccccc;">
                <div class="display-1 text-center mb-2 mt-1">
                  <div class="text-button">Wohlbefinden</div>
                  <v-icon class="d-inline-block mt-n2 ml-n2 mr-1" :size="36" color="blue">mdi-smiley</v-icon>
                  <v-icon color="dunkelblau" size="100"> {{ smiley(thisWeek.happyness) }}</v-icon>
                </div>
                <v-divider/>
                <div class="d-flex  justify-space-around pt-4 px-3">
                  <div v-for="(h,i) in happyness" class="">
                    <v-icon :color="h!==undefined ? 'dunkelblau' : 'grey lighten-2'">{{ smiley(h) }}</v-icon>
                    <p class="text-center text-caption">{{ (days[i]||{}).wochentag }}</p>
                  </div>
                </div>
              </div>
              <div v-else class="mt-6 mr-2 rounded-lg full_width" style="border: 1px solid #cccccc; overflow: hidden;">
                <div class="text-button full_width text-center">Wohlbefinden</div>
                <div class="d-flex justify-space-around ma-4">
                  <v-progress-circular indeterminate class="mx-auto" color="gelb"></v-progress-circular>
                </div>
              </div>

              <!--              eingabe-->
              <div v-if="loading>2" class="mt-6 mr-2 rounded-lg full_width" style="border: 1px solid #cccccc;">
                <div class="display-1 text-center mb-2 mt-1">
                  <div class="text-button">Eingabe</div>
                  <v-icon class="d-inline-block mt-n2 ml-n2" :size="36" color="orange">mdi-fire</v-icon>
                  <span>{{ inputSum }} von 7</span>
                </div>
                <v-divider/>
                <div class="d-flex  justify-space-around pt-4 px-3">
                  <div v-for="day in days" class="">
                    <v-icon :color="(day||{}).hasRecords ? 'orange' : 'grey lighten-2'">mdi-fire</v-icon>
                    <p class="text-center text-caption">{{ (day||{}).wochentag }}</p>
                  </div>
                </div>
                <v-divider v-if="hasWeekReport" />
                <div  v-if="hasWeekReport" class="d-flex  justify-space-around pt-4 px-3">
                  <div class="display-1 text-center">
                    <v-icon class="d-inline-block mt-n2 ml-n2" :size="36" color="orange">mdi-fire</v-icon>
                    <span>{{ inputStreak }}</span>
                    <p class="text-center text-caption">Eingabesträhne</p>
                  </div>
                </div>
              </div>
              <div v-else class="mt-6 mr-2 rounded-lg full_width" style="border: 1px solid #cccccc; overflow: hidden;">
                <div class="text-button full_width text-center">Eingabe</div>
                <div class="d-flex justify-space-around ma-4">
                  <v-progress-circular indeterminate class="mx-auto" color="gelb"></v-progress-circular>
                </div>
              </div>

              <!--              diamonds -->
              <div v-if="hasWeekReport">
                <div v-if="loading>3" class="mt-6 mr-2 rounded-lg full_width" style="border: 1px solid #cccccc;">
                  <div class="display-1 text-center mb-2 mt-1">
                    <div class="text-button">Diamanten</div>
                    <v-icon class="d-inline-block mt-n2 ml-n2 mr-1" :size="36" color="blue">mdi-diamond-stone</v-icon>
                    <span>{{ diamondsTotal }} (+{{diamonds}})</span>
                  </div>
                  <v-divider/>
                  <div class="d-flex  justify-space-around py-4 px-3">
                    <div>
                      Ein
                      <v-icon color="blue" size="medium">mdi-diamond-stone</v-icon>
                      je sieben
                      <v-icon color="orange" size="medium">mdi-fire</v-icon>
                      der Eingabesträhne von {{ inputStreak }}
                      <v-icon color="orange" size="medium">mdi-fire</v-icon>
                      <br/>
                    </div>
                  </div>
                </div>
                <div v-else class="mt-6 mr-2 rounded-lg full_width" style="border: 1px solid #cccccc; overflow: hidden;">
                  <div class="text-button full_width text-center">Diamanten</div>
                  <div class="d-flex justify-space-around ma-4">
                    <v-progress-circular indeterminate class="mx-auto" color="gelb"></v-progress-circular>
                  </div>
                </div>
              </div>

              <!--              medaillen -->
              <div v-if="loading>4" class="mt-6 mr-2 rounded-lg full_width" style="border: 1px solid #cccccc;">
                <div class="display-1 text-center mb-2 mt-1">
                  <div class="text-button">Medaillen</div>
                  <v-icon class="d-inline-block mt-n2 ml-n2 mr-1" :size="36" color="gelb">mdi-medal</v-icon>
                  <span>{{ medals.gold+medals.silver+medals.bronze }} von {{app.bereiche.length+1}}</span>
                </div>
                <v-divider/>
                <div class="d-flex  justify-space-around py-4 px-3">
                  <div>
                    <medal type="gold" style="height:30px;"></medal>
                    <span class="display-1">{{ medals.gold }}</span>
                  </div>
                  <div>
                    <medal type="silver" style="height:30px;"></medal>
                    <span class="display-1">{{ medals.silver }}</span>
                  </div>
                  <div>
                    <medal type="bronze" style="height:30px;"></medal>
                    <span class="display-1">{{ medals.bronze }}</span>
                  </div>
                </div>
              </div>
              <div v-else class="mt-6 mr-2 rounded-lg full_width" style="border: 1px solid #cccccc; overflow: hidden;">
                <div class="text-button full_width text-center">Medaillen</div>
                <div class="d-flex justify-space-around ma-4">
                  <v-progress-circular indeterminate class="mx-auto" color="gelb"></v-progress-circular>
                </div>
              </div>

              <!-- Prozent Ziele erreicht -->
              <div v-if="loading>5" class="mt-6 mr-2 rounded-lg full_width" style="border: 1px solid #cccccc;">
                <div class="display-1 text-center mb-2 mt-1">
                  <div class="text-button">Erreichte Ziele</div>
                  <v-icon class="d-inline-block mt-n2 ml-n2 mr-1" :size="36" color="blue">mdi-flag-checkered</v-icon>
                  <span>{{ percentZieleErreicht }} %</span>
                </div>
                <v-divider/>
                <div class="d-flex  justify-space-around py-4 px-3">
                  <div>
                    Du hast deine Ziele bei {{ anzahlZieleErreicht }} von {{ this.activities.length }} Aktivitäten erreicht.
                  </div>
                </div>
              </div>
              <div v-else class="mt-6 mr-2 rounded-lg full_width" style="border: 1px solid #cccccc; overflow: hidden;">
                <div class="text-button full_width text-center">Erreichte Ziele</div>
                <div class="d-flex justify-space-around ma-4">
                  <v-progress-circular indeterminate class="mx-auto" color="gelb"></v-progress-circular>
                </div>
              </div>

              <!--              bereiche-->
              <div v-if="loading>5" v-for="bereich in app.bereiche" class="mt-6 mr-2 rounded-lg full_width" style="border: 1px solid #cccccc; overflow: hidden;">
                <div class="display-3 text-center pb-2 pt-1" :style="{'background-color':getColor(bereich.bid)}">
                  <div class="text-button">{{bereich.name}}</div>
                  <!--                  <v-icon class="d-inline-block mt-n2 ml-n2" :size="36" color="orange">mdi-fire</v-icon>-->
                  <span>{{ thisWeek[bereich.bid] || 0 }}</span>
                </div>
                <v-divider/>
                <div class="text-center full_width pa-4" v-html="getIndexBeurteilung(thisWeek[bereich.bid])">
                </div>
                <v-divider/>
                <div class="d-flex justify-space-around pa-4 pb-2">
                  <div class="text-center">
                    <span class="display-1">{{ beforeLastWeek[bereich.bid] || 0 }}</span>
                    <p class="text-center text-caption">vorletzte Woche</p>
                  </div>
                  <div class="text-center">
                    <span class="display-1">{{ lastWeek[bereich.bid] || 0 }}</span>
                    <p class="text-center text-caption">letzte Woche</p>
                  </div>
                  <div class="text-center">
                    <span class="display-1">{{ thisWeek[bereich.bid] || 0 }}</span>
                    <p class="text-center text-caption">diese Woche</p>
                  </div>
                </div>
                <v-divider/>
                <div class="pa-4 pb-2">
                  <div v-for="activity in getActivitiesForBereich(bereich.bid)" class="d-flex justify-space-between mb-2">
                    <div>
                      <v-icon :color="getColor(bereich.bid)">{{getActivityIcon(activity)}}</v-icon>
                      {{activity.name}}
                    </div>
                    <div class="text-right">
                      {{getActivityInfo(activity)}}
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="mt-6 mr-2 rounded-lg full_width" style="border: 1px solid #cccccc; overflow: hidden;">
                <div class="text-button full_width text-center">Bereiche</div>
                <div class="d-flex justify-space-around ma-4">
                  <v-progress-circular indeterminate class="mx-auto" color="gelb"></v-progress-circular>
                </div>
              </div>

              <div class="d-flex">
                <v-btn class="mx-auto mt-3 mb-3" href="https://youtu.be/TwTYGYq5XG4" target="_blank">
                  <v-icon class="mr-2">mdi-play-box-outline</v-icon> Videoanleitung
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
          </div>
        </v-col>
      </div>
    </v-container>
  </v-main>
</template>

<script>
// @ is an alias to /src
import Vue from "vue";
import CenterContainer from "@/components/CenterContainer";
import {DateTime, Duration} from "luxon";
import Kinds from "@/components/Kinds";
import {Ziele} from "@/components/Ziele";
import ActivityLibrary from "@/components/ActivityLibrary";
import Datum from "@/components/Datum";
import Activity from "@/components/Activity";
import Bereiche from "@/components/Bereiche";
import {Badge} from "@/components/Badge";
import Medal from "@/components/Medal";
import {round} from "@/reusable/numbers";
import WeekPaginator from "@/components/Charts/WeekPaginator";

export default {
  name: 'Wochenreport',
  components: {CenterContainer, Medal, WeekPaginator },
  data: () => ({
    loading: 0,
    woche: 'nicht definiert',
    iso: undefined,
    isos: [],
    date: undefined,
    dateTime: undefined,
    days: [],
    inputSum: 0,
    availabilities: {}, // contains info for each month browsed in picker whether or not records exist on every day
    weekReport: {},
    happyness: [],
    thisWeek: {},
    lastWeek: {},
    beforeLastWeek: {},
    badges: [],
    medals: {gold: 0, silver: 0, bronze: 0},
    targets: {},
    currentTargets: undefined,
    activities:[],
    activitySums:{},
    hasWeekReport:false,
  }),
  mounted() {
    if (this.$app.desktop)
      this.$app.show_drawer = true;
    if (!this.$app.is_logged_in) {
      this.$store.commit("set", {key: "intern", value: false});
      if (this.$route.path != "/")
        this.$router.replace("/login?returnTo="+this.$route.path);
      return;
    }
    this.$store.commit("set", {key: "intern", value: true});
    //this.check_session(); // and if not, open user data form
    this.routeChanged(this.$route);
    //this.load(); // <-- called by routeChanged
  },
  beforeRouteUpdate(to, from, next) {
    //console.log("lobbyRouteChanged", to);
    this.routeChanged( to);
    next();
  },
  methods: {
    routeChanged(route) {
      if (route.params.date)
        this.iso = new Date(route.params.date);
      this.load();
    },
    // async check_session() {
    //   this.exit_if_not_logged_in();
    //   var user = await this.$backend.check_session();
    //   this.$app.save("user", user);
    //   this.exit_if_not_logged_in();
    // },
    // exit_if_not_logged_in() {
    //   if (!this.$app.is_logged_in) {
    //     this.$store.commit("set", {key: "intern", value: false});
    //     if (this.$route.path != "/")
    //       this.$router.replace("/login?returnTo="+this.$route.path);
    //     return;
    //   }
    //   this.$store.commit("set", {key: "intern", value: true});
    // },
    async load() {
      this.loading = 0;
      this.date = this.iso ? new Date(this.iso) : new Date(Date.now());
      this.dateTime = DateTime.fromJSDate(this.date).setLocale("de").startOf("week");
      this.iso = this.dateTime.toISODate();
      this.date = this.dateTime.toJSDate();
      var mo = this.dateTime;
      var so = this.dateTime.plus({'days': 6});
      this.woche = `${mo.day}.${mo.month}. - ${so.day}.${so.month}.`;
      this.isos=[];
      this.days = [];
      for (let i = 0; i < 7; i++) {
        var dayDateTime = this.dateTime.plus(Duration.fromObject({days: i}));
        var dayIso = dayDateTime.toISODate();
        this.isos.push(dayIso);
        this.days.push({wochentag: dayDateTime.weekdayShort.substr(0, 1)});
      }

      // loading index
      this.thisWeek = await this.$backend.get_object(Kinds.KIND_INDEX, this.iso) || {};
      this.lastWeek = await this.$backend.get_object(Kinds.KIND_INDEX, this.dateTime.minus({'days': 7}).toISODate()) || {};
      this.beforeLastWeek = await this.$backend.get_object(Kinds.KIND_INDEX, this.dateTime.minus({'days': 14}).toISODate()) || {};

      // load happyness
      this.loading = 1;
      this.happyness = [];
      for (var iso of this.isos) {
        var happyId = Activity.makeRecordId(iso, "happyness");
        var happyRecord = await this.$backend.get_object(Kinds.KIND_RECORD, happyId) || {};
        console.log(happyRecord);
        this.happyness.push(happyRecord.value);
      }

      // loading flammen
      this.loading = 2;
      var id = this.iso.substr(0, 7);
      this.availabilities = await this.$backend.get_object(Kinds.KIND_RECORD_AVAILABILITY, id) || {};
      this.inputSum = 0;
      for (let i = 0; i < 7; i++) {
        var dayDateTime = this.dateTime.plus(Duration.fromObject({days: i}));
        var dayIso = dayDateTime.toISODate();
        var hasInput = this.availabilities[dayIso] === true || this.availabilities[dayIso] === false;
        if (hasInput)
          this.inputSum++;
        console.log({i, dayIso, hasInput});
        this.days[i].hasRecords= hasInput;
      }

      // load report
      this.loading = 3;
      this.weekReport = await this.$backend.get_object(Kinds.KIND_WEEKREPORT, this.iso);
      this.hasWeekReport=!!this.weekReport;
      this.weekReport ||= {};

      // load medaillen
      this.loading = 4;
      this.badges = [];
      this.medals = {gold: 0, silver: 0, bronze: 0};
      var indexBadgeId = Badge.makeId(this.iso, 'index');
      var indexBadge = await this.$backend.get_object(Kinds.KIND_BADGE, indexBadgeId);
      if (indexBadge)
        this.badges.push(indexBadge);
      for (var bid of Bereiche.BIDS) {
        var badgeId = Badge.makeId(this.iso, bid);
        var badge = await this.$backend.get_object(Kinds.KIND_BADGE, badgeId);
        if (badge)
          this.badges.push(badge);
      }
      for(var badge of this.badges) {
        if (badge.value === "gold" || badge.value=== "diamond")
          this.medals.gold++;
        else if (badge.value === "silver")
          this.medals.silver++;
        else if (badge.value === "bronze")
          this.medals.bronze++;
      }

      // load targets
      this.loading = 5;
      this.targets = (await this.$backend.get_object(Kinds.KIND_ZIELE, Ziele.makeId(this.dateTime.year)) || {});
      this.currentTargets = new Ziele(this.targets).getTargets(this.iso);
      // load activities
      var activities = await this.$backend.get_all_objects(Kinds.KIND_ACTIVITY) || [];
      this.activities = ActivityLibrary.filterActivitiesByDate(activities, this.dateTime);
      this.activitySums = (await this.$backend.get_object(Kinds.KIND_ACTIVITY_SUMS, Datum.getStartOfWeekIso(this.date)) || {});

      this.loading = 1000;
    },
    smiley(happyness) {
      happyness ||= 0;
      if (happyness >= 2)
        return 'mdi-emoticon-outline';
      if (happyness >= 1)
        return 'mdi-emoticon-happy-outline';
      if (happyness >= 0)
        return 'mdi-emoticon-neutral-outline';
      if (happyness >= -1)
        return 'mdi-emoticon-sad-outline';
      if (happyness < -1)
        return 'mdi-emoticon-cry-outline';
      return 'mdi-emoticon-neutral-outline';
    },
    getIndexBeurteilung(index) {
      index ||= 0;
      if (index <= 0)
        return "Du hast dir offenbar eine Auszeit genommen<br/>(Index <= 0)";
      else if (index < 100)
        return "Du hast deine Ziele nicht vollständig erreicht<br/>(Index < 100)";
      else if (index === 100)
        return "Gratulation, du hast deine Ziele vollständig erreicht<br/>(Index = 100)";
      else if (index > 100)
        return "Wow, du hast deine Ziele übererfüllt<br/>(Index > 100)";
      return "Hmm."
    },
    getColor(bid){
      return Bereiche.COLORS_BY_NAME[bid];
    },
    getActivitiesForBereich(bid) {
      return this.activities.filter(x=>x.bereich==bid);
    },
    getActivityIcon(activity) {
      var target=this.currentTargets[activity.id] || activity.target || 1;
      if (activity.freq === ActivityLibrary.FREQ_DAILY) {
        target *= 7;
      }
      var value=this.activitySums[activity.id] || 0;
      var lessIsBetter = activity.lessIsBetter===true;
      if (!lessIsBetter && value >= target || lessIsBetter && value <= target)
        return "mdi-checkbox-marked-circle";
      return "mdi-checkbox-blank-circle-outline";
    },
    getActivityInfo(activity) {
      var freq=activity.freq;
      var target=this.currentTargets[activity.id] || activity.target || 1;
      if (activity.freq === ActivityLibrary.FREQ_DAILY) {
        freq = "pro Woche";
        target *= 7;
      }
      var value= round( this.activitySums[activity.id] || 0, 1);
      return `${value}/${target} ${activity.unit || 'mal'} ${freq}`;
    },
  },
  computed: {
    anzahlZieleErreicht() {
      var zieleErreicht=0;
      this.activities.forEach(activity => {
        var target=this.currentTargets[activity.id] || activity.target || 1;
        if (activity.freq === ActivityLibrary.FREQ_DAILY) {
          target *= 7;
        }
        var value=this.activitySums[activity.id] || 0;
        var lessIsBetter = activity.lessIsBetter===true;
        if (!lessIsBetter && value >= target || lessIsBetter && value <= target)
          zieleErreicht++;
      });
      return zieleErreicht;
    },
    percentZieleErreicht() {
      return round((this.anzahlZieleErreicht / this.activities.length)*100, 0);
    },
    app() {
      return this.$app;
    },
    bids() {
      return Bereiche.BIDS;
    },
    diamonds() {
      return (this.weekReport || {}).DiamondCount || 0;
    },
    diamondsTotal() {
      return (this.weekReport || {}).DiamondTotal || 0;
    },
    inputStreak() {
      return (this.weekReport || {}).InputStreak || 0;
    },
  },
  watch: {}
}
</script>

<style>
.rb {
  border: red 1px solid;
}

.full_width {
  width: 100%;
}
</style>